// extracted by mini-css-extract-plugin
export var content = "_6v-3";
export var list = "_6v-4";
export var settingsContent = "_6v-7";
export var settingsPanel = "_6v-8";
export var state = "_6v-6";
export var triggerBadge = "_6v-2";
export var triggerButton = "_6v-1";
export var triggerShell = "_6v-0";
export var unreadDot = "_6v-5";